import { FieldError } from 'react-hook-form';
import FormField from '../FormField/FormField';
import { errorId } from '../FormField/errorId';

type FormField = {
  id: string;
  label: string;
  required: boolean;
  validation?: {
    name: string;
    pattern: string;
    message: string;
  };
  extId?: boolean;
};

type Props = {
  field: FormField;
  register: any;
  error?: FieldError;
  value?: string;
};

const DynamicDateInput = ({ field, register, error }: Props) => {
  const { id, label, required } = field;

  return (
    <FormField
      htmlFor={id}
      label={label}
      required={required}
      error={error ? error.message || 'This field is required' : undefined}
    >
      <input
        id={id}
        className='field-input'
        type="date"
        aria-invalid={!!error}
        aria-required={required}
        aria-describedby={error ? errorId(id) : undefined}
        {...register(id, { required })}
      />
    </FormField>
  )
};

export default DynamicDateInput;
